import { useTranslations } from 'next-intl';
import { BetTypeContentProps } from '../bet-type-content';
import { DropdownIcon, QuestionIcon } from '@/components/icons/svg-icons';
import { useAccountInfo } from '@/hooks/query/account';
import { Button } from '@nf/ui';
import { useRef, useState } from 'react';
import { OddsButton } from '@/components/widgets/odds-button';
import clsx from 'clsx';
import { useOuterClick } from '@nf/utils-common/hooks';
import { useGetBetTypeSetting } from '@/hooks';

export const BetTypeEndingGame = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();
	const [isRuleOpen, setIsRuleOpen] = useState(false);
	const [isViewAll, setIsViewAll] = useState(false);
	const market = betTypeArray[0];
	const { betChoices } = getBetTypeSetting(market.BetTypeId, matchModel.GameID);
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const ruleTips = useRef<HTMLDivElement>(null);
	useOuterClick(ruleTips, () => {
		setIsRuleOpen(false);
	});

	const showBetTypeRule = () => {
		setIsRuleOpen(!isRuleOpen);
	}

	const showAllBetChoice = () => {
		setIsViewAll(!isViewAll);
	}

	return (
		<div className="bettype__content bettype__content--ending-game">
			<div
				className="bettype__question"
				data-open={isRuleOpen}
				ref={ruleTips}
			>
				<Button
					variant="icon"
					onClick={showBetTypeRule}
				>
					<QuestionIcon />
				</Button>
				<div
					className={clsx('tip', 'tip--detail tip--right')}
					data-open={isRuleOpen}
				>
					<div className="scrollbar scrollbar--tip">
						<div className="tip__content">
							{t('lbl_EndGameRuleTooltip')}
						</div>
					</div>
				</div>
			</div>
			<div className="bettype__group" data-open={isViewAll}>
				{
					betChoices.map((choice, index) => {
						return (
							<div className="bettype__item" key={choice.betTeam}>
								<div className="bettype__title">{choice.betTeam.replace(':', '-')}</div>
								<OddsButton
									key={`${market.Line}_${choice.betTeam}_${index}`}
									match={matchModel}
									market={market}
									selection={market.Selections[choice.betTeam]}
									homeTeamName={''}
									awayTeamName={''}
									betTeam={market.Selections[choice.betTeam].SelId}
									originalPrice={market.Selections[choice.betTeam].Price}
									sport={matchModel?.GameID}
									type="OU"
									oddsType={user?.OType}
									accountStatus={user?.ActStatus ?? 0}
								/>
							</div>
						)
					})
				}
			</div>
			<div className="bettype__more" data-open={isViewAll}>
				<div className="bettype__more-text">{!isViewAll ? t('lbl_ViewAll') : t('lbl_HideAll')}</div>
				<Button
					variant="icon"
					onClick={showAllBetChoice}
				>
					<DropdownIcon />
				</Button>
			</div>
		</div >
	);
}